import React, { useContext } from 'react'
import 'src/components/Stepper/Stepper.scss'
import { getStyles } from "src/helpers"
import { SessionContext } from "src/contexts/SessionContext"

interface IStepper extends React.HTMLAttributes<HTMLDivElement> {
    step?: number | null
}

const Stepper: React.FC<IStepper> = (props) => {
    const { className, step = null } = props
    const { currentRound } = useContext(SessionContext)

    const styles = getStyles("flex--column", [], className)

    return (
        <div className={styles}>
            <div className={"stepper"}>
                {Array(5).fill(null).map((item, index) => {
                    let isPassedStep
                    let isCurrentStep
                    if (step !== null) {
                        isPassedStep = index < step
                        isCurrentStep = index === step
                    } else {
                        isPassedStep = index < currentRound
                        isCurrentStep = index === currentRound
                    }

                    const stepperDotStyles = getStyles("stepper__dot", [{
                        decision: isCurrentStep || isPassedStep,
                        name: "current"
                    }])

                    const stepperLineStyles = getStyles("stepper__line", [{
                        decision: isPassedStep,
                        name: "passed"
                    }])

                    return (
                        <React.Fragment key={index}>
                            <div
                                className={stepperDotStyles}></div>
                            {index < 4
                                ?
                                <div className={stepperLineStyles}></div>
                                : null
                            }
                        </React.Fragment>
                    )
                })}
            </div>
        </div>
    )
}

export default Stepper